<template>

    <div id="agility_tab" class="flex_content scores_table_container">

         <div class="container data_table_view">

            <div v-if="dataLoaded">
                <TableWrapper tableContainerId="positions_table_container" class="with_shadow">

                    <template v-slot:tableHead>
                        <tr>
                            <th></th>
                            <th></th>
                            <!--
                            <th  :class="matchingSortingActive()"
                                class="sortable_column"
                                data-tooltip="Score de matching"
                                @click="reorderEval('matching_score')">%</th>
                            -->
                            <th>

                                <div class="icon_score_container">
                                    <span class="score_laurel"><iconLaurels /></span>
                                    <span class="score_index score1" >1</span>
                                </div>

                            </th>
                            <th>
                                <div class="icon_score_container">
                                    <span class="score_laurel"><iconLaurels /></span>
                                    <span class="score_index score2" >2</span>
                                </div>
                            </th>
                            <th>
                                <div class="icon_score_container">
                                    <span class="score_laurel"><iconLaurels /></span>
                                    <span class="score_index score3" >3</span>
                                </div>
                            </th>
                            <!--
                            <th>
                                <div class="icon_score_container">
                                    <span class="score_laurel"><iconLaurels /></span>
                                    <span class="score_index score4" >4</span>
                                </div>
                            </th>
                            <th>
                                <div class="icon_score_container">
                                    <span class="score_laurel"><iconLaurels /></span>
                                    <span class="score_index score5" >5</span>
                                </div>
                            </th>
                            <th></th>
                        -->
                        </tr>
                    </template>

                    <template v-slot:tableBody>

                        <tr class="evalution_item_name"
                            v-for="(evaluation, index) in evaluations"
                            :index="index" :key="evaluation.id" >

                            <td>
                                <!--<TableSelectCheckbox :checkboxId=" 'select_' + evaluation.id"
                                    @change="checkSelectedEval($event, evaluation.id)"
                                    :isChecked="isSelected(evaluation.id)" />-->
                            </td>

                            <td class="eval_username">
                                <router-link :to=" '/evaluations/' + evaluation.id ">
                                    {{ evaluation.candidate_username }}
                                </router-link>
                            </td>
                            <!--
                            <td class="matching_col"
                                :class="matchingClass(evaluation.saven_test.matching_score.toFixed(0))">
                                {{ evaluation.saven_test.matching_score.toFixed(0) }}%
                            </td>
                            -->
                            <td class="evalution_item_name">{{ titles[evaluation.saven_test.strengths_order[0][0]]['title'][$i18n.locale] }}</td>
                            <td class="evalution_item_name">{{ titles[evaluation.saven_test.strengths_order[1][0]]['title'][$i18n.locale] }}</td>
                            <td class="evalution_item_name">{{ titles[evaluation.saven_test.strengths_order[2][0]]['title'][$i18n.locale] }}</td>
                            <!--
                            <td class="evalution_item_name">{{ titles[evaluation.saven_test.strengths_order[3][0]]['title'][$i18n.locale] }}</td>
                            <td class="evalution_item_name">{{ titles[evaluation.saven_test.strengths_order[4][0]]['title'][$i18n.locale] }}</td>
                            -->
                        </tr>

                    </template>

                </TableWrapper>
            </div>
        </div>
    </div>

</template>

<script>
import s3StrengthsLabels from '@/locales/s3StrengthsLabels'

export default {
    name: 'PostitionEvalsStrengthCustomTab',
    props: ["evaluations", "currentPosition", "currentRef", "dataLoaded"],
    components: { },
    beforeCreate() {},
    data(){
        return {}
    },
    computed: {
        labels(){
            return s3StrengthsLabels[this.$i18n.locale]
        },
        dimensionsPlan(){
            return this.currentPosition.dimensions_plan
        },
        titles(){
            return this.dimensionsPlan.strenghts_custom_data
        }

    },
    methods: {
        isSelected(evaluationId){
            return this.$store.state.PositionStore.SelectedPositionEvalsIds.includes(evaluationId)
        },
        checkSelectedEval(isChecked, evaluationId){
            this.$emit("SelectionCheckBoxClicked",{isChecked: isChecked, evaluationId: evaluationId} )
        },
        reorderEval(key){
            this.current_sorting = key
            this.$emit('reorderEval', key)
        },
        // matchingSortingActive(){
        //     if ('matching_score' == this.current_sorting){
        //         return 'active'
        //     }else{
        //         return ''
        //     }
        // },
        // matchingClass(val){
        //     if(val < 25){return 'low'}
        //     if(val >= 25 && val < 50){return 'middleLow'}
        //     if(val >= 50 && val < 75){return 'middleHigh'}
        //     if(val >= 75){return 'high'}
        // }
    }
}
</script>

<style lang="scss">
</style>